import type { User } from "../types";

type SessionStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function persistSession(storage: SessionStorage, session: { token: string; user: User }) {
  storage.setItem("kidix_token", session.token);
  storage.setItem("kidix_user", JSON.stringify(session.user));
}

export function clearSession(storage: SessionStorage) {
  storage.removeItem("kidix_token");
  storage.removeItem("kidix_user");
}

export function readStoredUser(storage: SessionStorage): User | null {
  const stored = storage.getItem("kidix_user");
  if (!stored) return null;
  try {
    const user = JSON.parse(stored) as Partial<User>;
    if (!user.id || typeof user.email !== "string" || !user.name || !user.role) return null;
    return user as User;
  } catch {
    return null;
  }
}
